import React, { useState, useEffect } from "react"
import "../../Styles/Reservation.css"
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore"
import { db } from "../../Firebase/config"
import Notify from "../Componentslogic/Usenotifications"
import UsefetchCollectionAdmin from "../Componentslogic/Usefetchcollection"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import axios from "axios"
import ReactModal from "react-modal"
import { FaWhatsapp, FaEnvelope } from "react-icons/fa"
ReactModal.setAppElement("#root")
const AllUsers = () => {
  const {
    data: users,
    loading,
    // eslint-disable-next-line
    currentPage,
    nextPage,
    // eslint-disable-next-line
    previousPage,
    hasMore,
  } = UsefetchCollectionAdmin("users")

  const [searchQuery, setSearchQuery] = useState("")
  const [filteredUsers, setFilteredUsers] = useState([])
  const [UsersData, setallUsersData] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [emailSubject, setEmailSubject] = useState("")
  const [emailBody, setEmailBody] = useState("")
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false)
  const [whatsAppMessage, setWhatsAppMessage] = useState("")
  const [selectedPhone, setSelectedPhone] = useState("")

  const fetchAllReservations = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"))
      const allUsersData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setallUsersData(allUsersData)
    } catch (error) {
      console.error("Error fetching all reservations:", error)
    }
  }
  const handleSendWhatsApp = () => {
    if (!whatsAppMessage.trim()) {
      Notify("Please enter a message", "error") // Ensure message isn't empty
      return
    }

    const message = encodeURIComponent(whatsAppMessage)
    const phoneNumber = selectedPhone.replace(/\D/g, "") // Remove any non-numeric characters

    // Detect if user is on a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    // Use WhatsApp Web on desktop, WhatsApp App on mobile
    const whatsappUrl = isMobile
      ? `https://api.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Mobile opens WhatsApp App
      : `https://web.whatsapp.com/send?phone=2${phoneNumber}&text=${message}` // Desktop opens WhatsApp Web

    window.open(whatsappUrl, "_blank") // Opens in new tab
    setShowWhatsAppModal(false) // Close modal after sending
  }

  const handleOpenWhatsAppModal = (phone) => {
    setSelectedPhone(phone)
    setWhatsAppMessage("") // Reset message input
    setShowWhatsAppModal(true)
  }

  const handleCloseWhatsAppModal = () => {
    setShowWhatsAppModal(false)
  }

  useEffect(() => {
    // Fetch all reservations when the user starts typing a search query
    if (searchQuery && UsersData.length === 0) {
      fetchAllReservations()
    }
  }, [searchQuery, UsersData.length])

  useEffect(() => {
    const filtered = (searchQuery ? UsersData : users).map((user) => ({
      ...user,
      totalOrders: 0,
      mostOrderedItem: "Loading...", // Placeholder before fetching data
    }))
    setFilteredUsers(filtered)
  }, [searchQuery, users, UsersData])
  useEffect(() => {
    const fetchUserStats = async () => {
      const updatedUsers = await Promise.all(
        users.map(async (user) => {
          const { totalOrders, mostOrderedItem } = await getUserOrderData(
            user.phone || ""
          )
          const { totalReviews, above7Reviews, below7Reviews } =
            await getUserReviewStats(user.phone || "")

          return {
            ...user,
            totalOrders,
            mostOrderedItem,
            totalReviews,
            above7Reviews,
            below7Reviews,
          }
        })
      )
      setFilteredUsers(updatedUsers)
    }

    if (users.length > 0) {
      fetchUserStats()
    }
  }, [users])
  const getUserOrderData = async (phone) => {
    try {
      const ordersRef = collection(db, "Orders")
      const q = query(ordersRef, where("phone", "==", phone))
      const querySnapshot = await getDocs(q)

      let totalOrders = querySnapshot.size
      let itemCounts = {}

      querySnapshot.forEach((doc) => {
        const orderData = doc.data()
        orderData.cartItems?.forEach((item) => {
          const itemName = item.name || "Unknown"
          itemCounts[itemName] =
            (itemCounts[itemName] || 0) + item.CartTotalQuantity
        })
      })

      const mostOrderedItem = Object.entries(itemCounts).reduce(
        (max, item) => (item[1] > max[1] ? item : max),
        ["None", 0]
      )[0]

      return { totalOrders, mostOrderedItem }
    } catch (error) {
      console.error("Error fetching orders:", error)
      return { totalOrders: 0, mostOrderedItem: "N/A" }
    }
  }

  // ✅ Fetch total reviews and categorize them
  const getUserReviewStats = async (phone) => {
    try {
      const reviewsRef = collection(db, "Reviews")
      const q = query(reviewsRef, where("userphone", "==", phone))
      const querySnapshot = await getDocs(q)

      let totalReviews = querySnapshot.size
      let above7Reviews = 0
      let below7Reviews = 0

      querySnapshot.forEach((doc) => {
        const review = doc.data()
        const totalScore =
          (review.ratingFood || 0) + (review.ratingService || 0)

        if (totalScore >= 7) {
          above7Reviews++
        } else {
          below7Reviews++
        }
      })

      return { totalReviews, above7Reviews, below7Reviews }
    } catch (error) {
      console.error("Error fetching reviews:", error)
      return { totalReviews: 0, above7Reviews: 0, below7Reviews: 0 }
    }
  }

  const handleExtract = async () => {
    if (users.length > 0) {
      const usersData = users.map((user, index) => ({
        id: index + 1,
        "Client-Name": user.name,
        "Client-Email": user.email || " ",
        "Client-Area": user.area || "",
        "Client-Phone": user.phone,
      }))

      // Create a worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(usersData)
      worksheet["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
      ]

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users")

      // Convert the workbook to a binary string and create a Blob object
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" })

      // Use file-saver to save the file
      saveAs(blob, "Users.xlsx")
      Notify("Extracted", "success")
    } else {
      Notify("error occured", "error")
    }
  }

  const handleOpenModal = (user) => {
    setSelectedUser(user)
    setEmailSubject("")
    setEmailBody("")
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedUser(null)
  }

  const handleSendEmail = async () => {
    if (!emailSubject || !emailBody) {
      Notify("Please fill out all fields", "error")
      return
    }

    try {
      await axios.post("/api/send-custom-email", {
        name: selectedUser.name,
        email: selectedUser.email,
        subject: emailSubject,
        body: emailBody,
        senderName: "Team FireyNash",
      })
      Notify("Email sent successfully", "success")
      handleCloseModal()
    } catch (error) {
      console.error("Error sending email:", error)
      Notify("Failed to send email", "error")
    }
  }
  return (
    <div className="DeliveryContainer">
      <div className="dashboard-container">
        <main className="main-content">
          <header className="header d-flex justify-content-between align-items-center">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <button className="btns-Admin" onClick={handleExtract}>
              Extract To Excel
            </button>
          </header>

          <section className="orders-table ">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>email</th>
                  <th>Phone</th>
                  <th>Area</th>
                  <th>Total Orders</th>
                  <th>Most Ordered Item</th>
                  <th>Total Reviews</th>
                  <th>Reviews ≥ 7</th>
                  <th>Reviews &lt; 7</th>
                  <th>Actions </th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((order, index) => {
                  return (
                    <tr key={index}>
                      <td>{order.name}</td>
                      <td>{order.email} </td>
                      <td>{order.phone} </td>
                      <td>{order.area} </td>

                      <td>{order.totalOrders || 0}</td>
                      <td>{order.mostOrderedItem || "N/A"}</td>
                      <td>{order.totalReviews || 0}</td>
                      <td>{order.above7Reviews || 0}</td>
                      <td>{order.below7Reviews || 0}</td>
                      <td>
                        <div className="d-flex ">
                          {order.phone && (
                            <FaWhatsapp
                              size={24} // Adjust icon size
                              color="green"
                              className="whatsapp-icon mx-2"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleOpenWhatsAppModal(order.phone)
                              }
                            />
                          )}
                          {order.email && (
                            <FaEnvelope
                              size={24}
                              color="blue"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleOpenModal(order)}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {hasMore && !loading && (
              <div className="d-flex justify-content-center align-items-center">
                <button class="btn-Load mt-3" onClick={() => nextPage()}>
                  Load More
                </button>{" "}
              </div>
            )}
          </section>
        </main>
      </div>
      {/* React Modal for Sending Email */}
      <ReactModal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Send Email to {selectedUser?.name}</h2>
        <div className="form-group mt-3">
          <label>Email:</label>
          <input
            type="text"
            className="form-control"
            value={selectedUser?.email || ""}
            disabled
          />
        </div>
        <div className="form-group mt-3">
          <label>Subject:</label>
          <input
            type="text"
            className="form-control"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label>Message:</label>
          <textarea
            className="form-control"
            rows="5"
            value={emailBody}
            onChange={(e) => setEmailBody(e.target.value)}
          ></textarea>
        </div>
        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-secondary mx-2" onClick={handleCloseModal}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSendEmail}>
            Send Email
          </button>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={showWhatsAppModal}
        onRequestClose={handleCloseWhatsAppModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <h2 className="modal-title">Send WhatsApp Message</h2>

        <div className="form-group mt-3">
          <label>Phone Number:</label>
          <input
            type="text"
            className="form-control"
            value={selectedPhone}
            disabled
          />
        </div>

        <div className="form-group mt-3">
          <label>Message:</label>
          <textarea
            className="form-control"
            rows="4"
            value={whatsAppMessage}
            onChange={(e) => setWhatsAppMessage(e.target.value)}
            placeholder="Type your message here..."
          ></textarea>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn btn-secondary mx-2"
            onClick={handleCloseWhatsAppModal}
          >
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSendWhatsApp}>
            Send on WhatsApp
          </button>
        </div>
      </ReactModal>
    </div>
  )
}

export default AllUsers
